// src/utils/date.js
export function formatLocalTime(timeStr) {
  if (!timeStr) return '-';
  try {
    // 第一步：处理不同格式的时间字符串（兼容UTC/本地时间）
    let date;
    // 如果是UTC时间（带Z结尾），直接解析
    if (timeStr.endsWith('Z')) {
      date = new Date(timeStr);
    } else {
      // 如果是普通格式（2025-12-05 10:55:10），先尝试按UTC解析，再转本地
      const utcTimeStr = timeStr.replace(' ', 'T') + 'Z'; // 转为UTC格式
      date = new Date(utcTimeStr);
      // 如果解析失败，再按本地时间解析
      if (isNaN(date.getTime())) {
        date = new Date(timeStr);
      }
    }

    console.log('check valid:', timeStr);
    // 检查是否为有效日期
    if (isNaN(date.getTime())) return timeStr;

    console.log('it is valid:',date);
    // 第二步：显式获取本地时区的时间（避免解析偏差）
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  } catch (error) {
    console.error('时间转换失败：', error, '原始时间：', timeStr);
    return timeStr;
  }
}

